let previousMessage= 'Carregando...';

export function showModalCarregando(message) {
  const modal = document.getElementById('modal-carregando');

  const messageElement = modal.getElementsByClassName('texto-x-maior')[0];
  previousMessage = messageElement.innerHTML;
  messageElement.innerHTML = message;

  modal.classList.remove('oculta')
}

export function hideModalCarregando() {
  const modal = document.getElementById('modal-carregando');
  const messageElement = modal.getElementsByClassName('texto-x-maior')[0];
  messageElement.innerHTML = previousMessage;

  modal.classList.add('oculta')
}